import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ToolService } from '../../../service/tool.service';

import { SetToolSearch } from '../../../store/toolSearch/tool-search-action';


@Component({
  selector: 'app-tool-search',
  templateUrl: './tool-search.component.html',
  styleUrls: ['./tool-search.component.less']
})
export class ToolSearchComponent implements OnInit {

  validateForm: FormGroup;
  toolType = [];

  constructor(private fb: FormBuilder, private store: Store, private toolService: ToolService) { }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      toolId: [null],
      toolName: [null],
      toolType: [null]
    });
    this.store.dispatch(new SetToolSearch(this.validateForm.value));
    this.getToolType();
  }

  submitForm(){
    // alert(this.validateForm.value.toolId);
    this.validateForm.setValue({
      toolId: this.validateForm.value.toolId,
      toolName: this.validateForm.value.toolName,
      toolType: this.validateForm.value.toolType,
    });
    this.store.dispatch(new SetToolSearch(this.validateForm.value));
  }

  resetForm(){
    this.validateForm.reset();
    this.store.dispatch(new SetToolSearch(this.validateForm.value));
  }

  getToolType(){
    this.toolService.getToolTypeList().subscribe((response: any) => {
      if (response.code === 200) {
        this.toolType = response.data;
        // console.log(this.toolType);
      }
    });
  }
}
